<template>
    <div id="app">
        <vue-progress-bar></vue-progress-bar>

        <div v-if="routePartialType === 'full'">
            <div class="page-wrapper">
                <!-- <navbar></navbar> -->

                <div class="main-content-wrapper" role="main">
                    <router-view></router-view>
                </div>

                <footer-main></footer-main>
            </div>
        </div>

        <div v-if="routePartialType === 'meta'">
            <div class="main-content-wrapper" role="main">
                <router-view></router-view>
            </div>
        </div>

        <back-to-top></back-to-top>
        <rules-modal></rules-modal>
        <enter-success-modal></enter-success-modal>
    </div>
</template>

<script>
/* eslint-disable-next-line no-unused-vars  */
// import fixedNavHelper from '@/common/fixedNavHelper'

export default {
    name: 'app',
    computed: {
        routePartialType () {
            return this.$route.meta.partialType
        }
    },
    methods: {
    },
    mounted () {
    },
    created () {

    }
}
</script>

<style>
</style>